import "./list.scss"
import Sidebar from "../../components/sidebar/Sidebar"
import Navbar from "../../components/navbar/Navbar"
import Datatable from "../../components/datatable/DatatableTiendas"
import { useSidebarState } from "../../components/sidebar/SidebarStateContext";

const ListTiendas = () => {
  const { collapsed } = useSidebarState();

  // Agregar una clase basada en el estado de colapso
  const containerClass = collapsed ? "listContainer collapsed" : "listContainer";

  return (
    <div data-testid="sidebar3" className="list">
      <Sidebar />
      <div data-testid="navbar3" className={containerClass}>
        <Navbar />
        <Datatable />
      </div>
    </div>
  )
}

export default ListTiendas